import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "ItemName",
    isNumber: true,
    isSum: true,
  },
];

export const CheckItemAnalysis = {
  label: "檢查項目",
  key: "CheckItemAnalysis",
  path: "ElderlyHealthCheckup/CheckItemAnalysis",
  api: "TCS_V_OldStudyList03V",
  render: (options) => (
    <Diagram.ElderlyHealthCheckup.CheckItemAnalysis {...options} />
  ),
  isPercent: true,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "result",
      field: "result",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
